export const anetaStawiszynskaBiarda = {
    'firstName': 'Aneta',
    'lastName': 'Stawiszyńska-Biarda',
    'mydrId': 'anetastawiszyńska-biarda',
    'profession': 'Psycholog, trener TUS',
    'avatar': 'aneta-stawiszynska-biarda.webp',
    'slug': 'psycholog-aneta-stawiszynska-biarda',
    'locations': ['torun'],
    'services': [
        ['psychology', 'consultation'],
    ]
}